import React from 'react';
import ReactDOM from 'react-dom/client';
import "./css/App.css"
import App from "./App.js"

const mainRoot = ReactDOM.createRoot(document.getElementById('app'));
mainRoot.render(
  <App />
);